if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (document.body.classList.contains('cart-redirection-drawer')) {
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        } else {
            this.cart = null;
        }
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // checkSubscriptionInCart();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
         /* ✅ PASTE THIS DIRECTLY BELOW */

        // if(document.body.classList.contains('main-black-friday')){
        //   // Save main product values
        //   const mainId = formData.get('id');
        //   const mainQty = formData.get('quantity') || 1;

        //   // Remove default Shopify fields
        //   formData.delete('id');
        //   formData.delete('quantity');

        //   // Insert main product in multi-item format
        //   formData.append("items[0][id]", mainId);
        //   formData.append("items[0][quantity]", mainQty);

        //   // OPTIONAL EXTRA PRODUCT — only if form contains it
        //   const extraProductId = formData.get('extra_product_id');
        //   if (extraProductId) {
        //     formData.append("items[1][id]", extraProductId);
        //     formData.append("items[1][quantity]", "1");
        //   }
        // }
        /* ✅ STOP PASTING HERE — DO NOT CHANGE ANYTHING BELOW */
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          const cartDrawer = document.querySelector(".template--product .drawer"); 
            if (cartDrawer) {
              cartDrawer.style.display = "none";
            }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            console.log('response---update cart',response);
            // this.cart.renderContents(response);

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
             else if (!this.cart) {   
              // if (!document.body.classList.contains('main-black-friday')) {
                checkSubscriptionInCart();
              // }
              setTimeout(function () {
                  if (document.querySelectorAll(".cart-redirection-checkout").length > 0) {
                    document.body.classList.remove('overflow-hidden');
                    if (document.body.classList.contains('overflow-hidden')) {
                      console.log('finally--------remove');
                    }
                      window.location.href = "/checkout"; 
                    } else {
                      // window.location = window.routes.cart_url; 
                    }
               }, 5000);
            return;
          }
            if (document.body.classList.contains('cart-redirection-drawer')) {
              // if (!document.body.classList.contains('main-black-friday')) {
                checkSubscriptionInCart();
              // }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
                      var redirectedAlready = false;
                      function goToCheckoutIfNeeded() {
                        if (redirectedAlready) return;
                        redirectedAlready = true;
                        document.removeEventListener('cart:subscriptionSynced', goToCheckoutIfNeeded);
                        if (document.querySelectorAll(".cart-redirection-checkout").length > 0) {
                          document.body.classList.remove('overflow-hidden');
                          window.location.href = "/checkout";
                        }
                      }
                      document.addEventListener('cart:subscriptionSynced', goToCheckoutIfNeeded);
                      setTimeout(goToCheckoutIfNeeded, 6000);
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            console.log('finally--------');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
 